import { render, staticRenderFns } from "./ContactsResponsible.vue?vue&type=template&id=1b1dea7b&scoped=true"
import script from "./ContactsResponsible.vue?vue&type=script&lang=js"
export * from "./ContactsResponsible.vue?vue&type=script&lang=js"
import style0 from "./ContactsResponsible.vue?vue&type=style&index=0&id=1b1dea7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1dea7b",
  null
  
)

export default component.exports